import React, { Fragment, useMemo } from 'react';
import { LoadingButton } from '@mui/lab';
import { ListItemSecondaryAction, Typography } from '@mui/material';
import { BUTTON_VARIANTS } from '../common/constants/constants';
import I18n from '../common/i18n/I18n';
import { useStyling } from '../common/Theme';
import { ProductionOrganizationInfoWithKey } from './helpers/organizationUtils';

type ListActionButtonsProps = {
    isAdded: boolean;
    prodOrg: ProductionOrganizationInfoWithKey;
    onMarkClick: (p: ProductionOrganizationInfoWithKey) => void;
    onUnmarkClick: (p: ProductionOrganizationInfoWithKey) => void;
    isLoading: boolean;
    isDisabled: boolean;
};

export default ({ isAdded, prodOrg, onMarkClick, onUnmarkClick, isLoading, isDisabled }: ListActionButtonsProps) => {
    const { theme } = useStyling();

    return (
        <ListItemSecondaryAction sx={{ display: 'flex', alignItems: 'center' }}>
            {' '}
            {isAdded && (
                <Typography sx={{ color: theme.palette.text.disabled, mr: 2 }}>
                    <I18n token="form.added" />
                </Typography>
            )}
            <LoadingButton
                variant={BUTTON_VARIANTS.text}
                loading={isLoading}
                disabled={isDisabled}
                onClick={(e) => {
                    e.stopPropagation();
                    isAdded ? onUnmarkClick(prodOrg) : onMarkClick(prodOrg);
                }}
            >
                {isAdded ? <I18n token="form.remove" /> : <I18n token="form.add" />}
            </LoadingButton>
        </ListItemSecondaryAction>
    );
};
